import { useAuth } from "../context/AuthContext";
import { IonButton } from "@ionic/react";

const LoginButton = () => {
    const {isAuthenticated, loginWithRedirect,logout, loginWithPopup } = useAuth()
    return !isAuthenticated?<IonButton onClick={() => loginWithPopup()}>Log in</IonButton>:<IonButton onClick={()=>logout()}>Log out</IonButton>
};

export default LoginButton;